export interface SieveQuery {
  page?: number;
  pageSize?: number;
  filters?: string;
  sorts?: string;
}

export interface PagedResult<T> {
  items: T[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export const toSieveParams = (q: SieveQuery): Record<string, string | number> => {
  const out: Record<string, string | number> = {};

  if (q.page) out.Page = q.page;
  if (q.pageSize) out.PageSize = q.pageSize;
  if (q.filters) out.Filters = q.filters;
  if (q.sorts) out.Sorts = q.sorts;

  return out;
};

/**
 * Escapes a user-supplied value for use inside a Sieve filter expression. Sieve treats `,` as the
 * AND separator, `|` as the OR separator and `\` as the escape character, so each is
 * backslash-escaped.
 */
export const escapeSieveValue = (value: string): string => value.replace(/[\\,|]/g, (match) => `\\${match}`);
